import React, { useState } from "react";
import Skills from "./Skills";
import profilePic from "../website pic/Anmol 18.jpg";
import "./About.css";

const TABS = ["Overview", "Experience", "Skills"];

const About = () => {
  const [tab, setTab] = useState("Overview");

  const renderContent = () => {
    switch (tab) {
      case "Experience":
        return (
          <div className="about-panel">
            <h2 className="about-heading">Work Experience Timeline</h2>

            <div className="timeline">
              {/* Prairie Mobile */}
              <div className="timeline-item">
                <div className="timeline-dot" />
                <div className="timeline-card">
                  <p className="timeline-date">
                    May 2021 – May 2025 · Saskatoon, SK
                  </p>
                  <h3 className="timeline-title">
                    Wireless Team Member · Prairie Mobile Communications
                  </h3>
                  <p className="timeline-body">
                    Provided technical support for iOS/Android devices, handled setup,
                    email/network issues, and helped restore service. Matched customers
                    with the right devices/plans while consistently meeting sales targets
                    through clear, empathetic communication.
                  </p>
                  <ul className="timeline-list">
                    <li>Hands-on troubleshooting across phones & connected devices</li>
                    <li>Owned issue resolution: porting, billing fixes, escalations</li>
                    <li>Documented cases in POS/CRM to keep workflows clean</li>
                  </ul>
                </div>
              </div>

              {/* Kaya Technologies */}
              <div className="timeline-item">
                <div className="timeline-dot" />
                <div className="timeline-card">
                  <p className="timeline-date">Jun 2023 – Jun 2024 · Regina, SK</p>
                  <h3 className="timeline-title">Intern · Kaya Technologies Ltd.</h3>
                  <p className="timeline-body">
                    Supported backend and infra work—tuning SQL, debugging Java, and
                    helping with deployments and monitoring in a small, focused team.
                  </p>
                  <ul className="timeline-list">
                    <li>Assisted with SQL query analysis & optimization</li>
                    <li>Participated in Java code reviews and debugging sessions</li>
                    <li>Helped with deployments, releases, and monitoring</li>
                  </ul>
                </div>
              </div>
               {/* University */}
              <div className="timeline-item">
                <div className="timeline-dot" />
                <div className="timeline-card">
                  <p className="timeline-date">Graduated Jun 2025 · Saskatoon, SK</p>
                  <h3 className="timeline-title">
                    B.Sc. Computer Science · University of Saskatchewan
                  </h3>
                  <p className="timeline-body">
                    Built strong fundamentals across algorithms, web development,
                    databases, and human–computer interaction while working part-time in
                    tech support.
                  </p>
                  <ul className="timeline-list">
                    <li>Data Structures & Algorithms</li>
                    <li>Web Development & Database Systems</li>
                    <li>Human–Computer Interaction & UX principles</li>
                  </ul>
                </div>
              </div>





            </div>
          </div>
        );

     

      case "Skills":
        return (
          <div className="about-panel">
            <h2 className="about-heading">Skill Map</h2>
            <Skills />
            <div className="skills-tags">
              <div>
                <h3 className="skills-heading">Core Stack</h3>
                <p>
                  JavaScript/TypeScript · React · Node.js (Express) · REST APIs ·
                  SQL (PostgreSQL/MySQL) · MongoDB
                </p>
              </div>
              <div>
                <h3 className="skills-heading">DevOps & Infra</h3>
                <p>Git/GitHub · Docker · CI/CD (GitHub Actions) · Linux/macOS</p>
              </div>
              <div>
                <h3 className="skills-heading">Extras</h3>
                <p>Python · Java · C/C++ · Networking basics · Testing & QA</p>
              </div>
            </div>
          </div>
        );

      case "Overview":
      default:
        return (
          <div className="about-panel">
            <h2 className="about-heading">What I Bring</h2>
            <p className="about-description">
              I’m <strong>Anmol Dhunna</strong>, a front-end and full-stack developer
              focused on accessible interfaces, dependable application logic, and
              products that make complicated workflows feel straightforward.
            </p>
            <p className="about-description">
              My computer science background covers algorithms, databases, HCI, and
              web development. Four years in customer-facing technical support taught
              me how to investigate problems, communicate clearly, and design for the
              person on the other side of the screen.
            </p>

            <div className="focus-grid">
              <div className="focus-card">
                <h3>Interface & Experience</h3>
                <p>
                  Clean, responsive UI with clear states, motion, and layouts that put
                  users at ease.
                </p>
              </div>
              <div className="focus-card">
                <h3>Reliable Systems</h3>
                <p>
                  APIs, databases, and infra that don&apos;t feel fragile when real
                  users start pushing them.
                </p>
              </div>
              <div className="focus-card">
                <h3>Human Support</h3>
                <p>
                  Years of customer-facing tech support mean I design with real
                  people—and real problems—in mind.
                </p>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <section className="about-section">
      <div className="about-inner">
        {/* LEFT SIDE – Profile Card */}
        <aside className="about-profile">
          <div className="about-avatar-orbit">
            <div className="about-avatar-ring about-avatar-ring-1" />
            <div className="about-avatar-ring about-avatar-ring-2" />
            <div className="about-avatar-ring about-avatar-ring-3" />
            <div className="about-avatar-frame">
              <img
                src={profilePic}
                alt="Anmol Dhunna"
                className="about-avatar-img"
                loading="lazy"
                decoding="async"
              />
              <div className="about-avatar-badge">Player</div>
            </div>
          </div>

          <div className="about-name-block">
            <p className="about-name-en">Anmol Dhunna</p>
            <p className="about-name-jp"></p>
            <p className="about-role">Front-End / Full-Stack Developer</p>
          </div>

          <div className="about-stats-grid">
            <div className="about-stat">
              <span className="about-stat-label">Based in</span>
              <span className="about-stat-value">Toronto, Ontario</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-label">Degree</span>
              <span className="about-stat-value">B.Sc. Computer Science</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-label">Experience</span>
              <span className="about-stat-value">4+ years in tech support</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-label">Current Quest</span>
              <span className="about-stat-value">
                Developer role & new builds
              </span>
            </div>
          </div>

          <div className="about-links">
            <a href="mailto:Anmoldhunna71@gmail.com">Email</a>
            <a
              href="https://github.com/Anmol1676"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
            <a
              href="https://www.linkedin.com/in/anmolpreet-dhunna-b4ba82217/"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          
            <a href="/PublicResume.pdf" target="_blank" rel="noreferrer" className="about-resume-chip">
              View Résumé
            </a>
          </div>
        </aside>

        {/* RIGHT SIDE – Tabbed Content */}
        <main className="about-content">
          <div className="about-tabs">
            {TABS.map((label) => (
              <button
                key={label}
                className={`about-tab ${tab === label ? "active" : ""}`}
                onClick={() => setTab(label)}
              >
                {label}
              </button>
            ))}
          </div>

          {renderContent()}
        </main>
      </div>
    </section>
  );
};

export default About;
